import axios from "axios";
import { getToken } from "./auth.service";
import {
  getCachedAuthorization,
  hasPermission,
  loadAuthorization,
} from "auth/authorization.service";

const API_URL = process.env.REACT_APP_API_URL;
const PERMISSION_ERROR = "Loi kiem tra quyen";

export async function checkPermission(permission) {
  try {
    const cachedAuthorization = getCachedAuthorization();
    if (cachedAuthorization) {
      const allowed = hasPermission(permission, cachedAuthorization);
      return {
        Success: true,
        HasPermission: allowed,
        success: true,
        hasPermission: allowed,
        message: allowed ? "Quyền được cấp từ authorization cache" : "Quyền bị từ chối từ authorization cache",
      };
    }

    const token = getToken();
    if (token) {
      try {
        const authorization = await loadAuthorization();
        if (authorization) {
          const allowed = hasPermission(permission, authorization);
          return {
            Success: true,
            HasPermission: allowed,
            success: true,
            hasPermission: allowed,
            message: allowed ? "Quyền được cấp từ authorization" : "Quyền bị từ chối từ authorization",
          };
        }
      } catch {
        // Fallback to the legacy check endpoint below.
      }
    }

    const response = await axios.get(`${API_URL}/api/Permission/check`, {
      params: { permission },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = response.data || {};
    return {
      ...data,
      success: data.success ?? data.Success ?? false,
      hasPermission: data.hasPermission ?? data.HasPermission ?? false,
      message: data.message ?? data.Message,
    };
  } catch (error) {
    return {
      Success: false,
      HasPermission: false,
      Message: PERMISSION_ERROR,
      success: false,
      hasPermission: false,
      message: PERMISSION_ERROR,
    };
  }
}

export async function checkPermissionsBatch(permissions) {
  try {
    let authorization = getCachedAuthorization();
    if (!authorization && getToken()) {
      try {
        authorization = await loadAuthorization();
      } catch {
        authorization = null;
      }
    }
    if (authorization) {
      const results = Object.fromEntries(
        (permissions || []).map((permission) => [permission, hasPermission(permission, authorization)]),
      );

      return {
        Success: true,
        Results: results,
        success: true,
        results,
      };
    }

    const token = getToken();
    const response = await axios.post(
      `${API_URL}/api/Permission/check-batch`,
      { permissions },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    const data = response.data || {};
    return {
      ...data,
      success: data.success ?? data.Success ?? false,
      results: data.results ?? data.Results ?? {},
    };
  } catch (error) {
    return {
      Success: false,
      Results: {},
      Message: PERMISSION_ERROR,
      success: false,
      results: {},
    };
  }
}

export async function getUserPermissions(userId) {
  try {
    const authorization = getCachedAuthorization();
    const currentUserId = authorization?.user?.userId ?? authorization?.user?.UserId;
    if (authorization && (!userId || Number(userId) === Number(currentUserId))) {
      return authorization.permissions.map((permissionCode) => ({
        permissionCode,
        PermissionCode: permissionCode,
        permissionName: permissionCode,
        PermissionName: permissionCode,
      }));
    }

    const token = getToken();
    const response = await axios.get(
      `${API_URL}/api/Permission/user/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    const data = response.data;

    if (data && (data.data || data.Data)) {
      return data.data || data.Data;
    }

    if (Array.isArray(data)) {
      return data;
    }

    if (data && data.success && data.data) {
      return data.data;
    }

    console.warn("DEBUG permission.service: Unexpected API response format:", data);
    return [];
  } catch (error) {
    console.error("Error getting user permissions:", error);
    throw error;
  }
}
